import { render, staticRenderFns } from "./LastNameInput.vue?vue&type=template&id=664ff0d1&"
import script from "./LastNameInput.vue?vue&type=script&lang=ts&"
export * from "./LastNameInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports